import { jsx } from 'react/jsx-runtime';

function Box({ spacingVertical, spacingHorizontal, spacing = "base", style, children, }) {
    const spacingStyle = {
        padding: `var(--space-${spacingVertical !== null && spacingVertical !== void 0 ? spacingVertical : spacing}) var(--space-${spacingHorizontal !== null && spacingHorizontal !== void 0 ? spacingHorizontal : spacing})`,
    };
    return (jsx("div", { style: Object.assign(Object.assign(Object.assign({}, spacingStyle), style), { overflow: "auto", lineHeight: 0 }), children: children }));
}

export { Box };
//# sourceMappingURL=Box.js.map
